import styled from "styled-components";
import { palette } from "styled-theme";

const CalenderWrapper = styled.div`
  height: 100%;
  overflow: auto;
  .rbc-event {
    background-color: ${palette("primary", 0)};
  }
  .rbc-event-label {
    display: none;
  }
  .rbc-allday-cell {
    display: none;
  }
  .rbc-time-header .rbc-label {
    width: 49.1641px;
    min-width: 49.1641px;
    max-width: 49.1641px;
  }
  .absence {
    .rbc-timeslot-group {
      border-color: transparent;
    }
  }
  .rbc-header.absence {
    background-color: transparent !important;
    border-color: #ddd !important;
  }
`;

export default CalenderWrapper;
